export default "__VITE_ASSET__FASaYzk$__"